<template>
  <div class="account-page">
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="account-content">
        <div class="login-wrapper">

          <div class="login-img">
            <img src="../../../assets/img/login.png" alt="img" size="10" />
          </div>
          <div class="login-content">
            <div class="login-userset">
              <div class="login-logo logo-normal">
                <img src="../../../assets/img/logo.png" alt="img" />
              </div>
              <router-link to="/index" class="login-logo logo-white">
                <img src="../../../assets/img/logo-white.png" alt="" />
              </router-link>
              <div class="login-userheading">
                <h3 v-if="showAdmin">Sign In As <strong class="text-success"><u>Owner</u></strong></h3>
                <h3 v-if="showOwner">Sign In As <strong class="text-secondary"><u>Admin</u></strong></h3>
                <h4>Please login to your account</h4>
              </div>
              <Form class="login" @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
                <div class="form-login">
                  <label>Phone Number</label>
                  <div class="form-addons">
                    <!-- <Field name="phone" type="text" v-model="phone" class="form-control" aria-placeholder=""
                      :class="{ 'is-invalid': errors.phone }" :maxlength="14" /> -->

                    <Field name="phone" v-slot="{ field }">
                      <vue-tel-input
                        v-bind="field"
                        :value="phone"
                        input-class="form-control"
                        mode="international"
                        :auto-format="true"
                        :class="{ 'is-invalid': errors.phone }"
                        @input="(number, phoneObject) => {
                          onPhoneInput(number, phoneObject)   // update your local phone if you still want it
                        }"
                      />
                    </Field>

                    <div class="invalid-feedback">{{ errors.phone }}</div>
                    <div class="emailshow text-danger" id="email"></div>

                    <div class="position-absolute me-2 end-0 top-0 h-100 d-flex align-items-center"
                      v-if="!(errors.phone)">
                      <i class='bx bx-phone text-secondary' alt="img"></i>
                    </div>

                  </div>
                </div>
               
                <div class="form-login">
                  <button type="submit" class="btn btn-login">Sign In</button>
                </div>
              </Form>
              <div class="signinform text-center d-flex justify-content-between">
                <div>
                  Login as
                  <a href="" @click="setTipeLogin('admin');" class="hover-a" v-if="showAdmin">Admin</a>
                  <a href="" @click="setTipeLogin('owner')" class="hover-a" v-if="showOwner">Owner</a>
                </div>

                <div>
                  <h4>
                    Don’t have an account?
                    <a class="hover-a" @click="signUp">Sign up</a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>
<script>

import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import axios from "axios";
import { goPage, base_url } from "@/assets/js/function";

import { VueTelInput } from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

export default {
  components: {
    Form,
    Field,
    VueTelInput,

  },
  data() {
    return {
      showPassword: false,
      password: null,
      phone: "",
      showAdmin: true,
      showOwner: false,
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    onPhoneInput(number, phoneObject) {
      if (phoneObject?.formatted) {
        this.phone = phoneObject.formatted;
       
      }
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    setTipeLogin(status) {
      localStorage.setItem('tipe_login', status); 
    },
    signUp() {
      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'v3/auth/services';
      } else {
        this.api = base_url + 'v3/auth/services';
      }
      axios
        .get(this.api)
        .then((response) => {
          if (response.data.status == true) {
            window.open(response.data.data.link_register, "_blank");
          } else {
            AlertPopup2("error", "", response.data.message);
          }
        })
        .catch((error) => {
          ErrorConnectionTimeOut(error);
        });

    },
  },
  created() {
    // localStorage.clear();
    if (localStorage.getItem('tipe_login') == undefined ||
      localStorage.getItem('tipe_login') == 'owner' ||
      localStorage.getItem('tipe_login') == null) {
      this.showAdmin = true;
      this.showOwner = false;
      localStorage.setItem('tipe_login', 'owner');
    } else {
      this.showAdmin = false;
      this.showOwner = true;
      localStorage.setItem('tipe_login', 'admin');
    }
  },
  setup() {
    const schema = Yup.object().shape({
      phone: Yup.string().required("Phone Number is required").min(11, "Phone Number must be at least 11 characters"),
    });
    const onSubmit = (values) => {
      localStorage.setItem("phone", values.phone);
      goPage('pin');
    };
    return {
      schema,
      onSubmit,
    };
  },
};
</script>
